/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCreationIntentDto } from '../models/CreateCreationIntentDto';
import type { CreationIntentResponseDto } from '../models/CreationIntentResponseDto';
import type { CreationStreamPreviewRequestDto } from '../models/CreationStreamPreviewRequestDto';
import type { CreationStreamPreviewResponseDto } from '../models/CreationStreamPreviewResponseDto';
import type { CreationStreamResponseDto } from '../models/CreationStreamResponseDto';
import type { IngredientHintsRequestDto } from '../models/IngredientHintsRequestDto';
import type { IngredientHintsResponseDto } from '../models/IngredientHintsResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CreationIntentService {
    /**
     * Create a post from a user intent. Returns projectId immediately; generation runs in the background.
     * @param requestBody
     * @returns CreationIntentResponseDto
     * @throws ApiError
     */
    public static creationIntentControllerCreateV1(
        requestBody: CreateCreationIntentDto,
    ): CancelablePromise<CreationIntentResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creation-intents',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * The creation stream: proven post formats ranked for this business (the Home 'Inspire me' rail). v1 is the honest format catalog with a stable daily rotation; per-business ranking and brand-rendered previews layer on later.
     * @returns CreationStreamResponseDto
     * @throws ApiError
     */
    public static creationIntentControllerStreamV1(): CancelablePromise<CreationStreamResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creation-intents/stream',
        });
    }
    /**
     * Render one stream card's preview in this business's brand (deterministic worker render, no models). Null imageUrl when unavailable — the client keeps its text card.
     * @param requestBody
     * @returns CreationStreamPreviewResponseDto
     * @throws ApiError
     */
    public static creationIntentControllerStreamPreviewV1(
        requestBody: CreationStreamPreviewRequestDto,
    ): CancelablePromise<CreationStreamPreviewResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creation-intents/stream/preview',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Prompt-aware ingredient hints for the hero's frame shelf: 1-3 specific photos the owner could grab right now for the idea they typed. Best-effort; empty keeps the generic frames.
     * @param requestBody
     * @returns IngredientHintsResponseDto
     * @throws ApiError
     */
    public static creationIntentControllerIngredientHintsV1(
        requestBody: IngredientHintsRequestDto,
    ): CancelablePromise<IngredientHintsResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creation-intents/ingredient-hints',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
